import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXv1_ABI } from "./abi/LPXv1_ABI";
import { LPXCtrlPools_v5ABI } from "./abi/LPXCtrlPools_v5ABI";
import { LPXConfig, LPXConfigPack, LPXReserves } from "./LPXContract";

export class LPXInfo{
    public configs_:LPXConfigFull[];
    public reserves_:LPXReserves[];
}
// export class LPXReserves{
//     public fundReserve:string;
//     public fundImgReserve:string;
//     public anchorReserve:string;
//     public anchorImgReserve:string;
// }
export class LPXConfigFull{
    public manager:string;
    public fundToken:string;
    public anchorToken:string;
    public ntzIndex:string;
    public rewardIndex:string;
    public startRatio:string;
    public sellRatio:string;
    public totalShares:string;
    public lastStartDropTimestamp:string;
}


// export class LPXConfig{
//     public pack:string; //bi
//     public manager:string; //adr
//     public fundToken:string; //adr
//     public anchorToken:string; //adr
//     public totalShares:string; //bi
// }

export class LPXCtrlPoolsContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXCtrlPools_v5ABI.GetABI(), provider);
    }

    //function getPackConfigPack(uint pack_, ILPXv1.ConfigPack calldata unpack_) external pure returns(uint result_) { result_ = _packConfigPack(pack_, unpack_); }
    async getPackConfigPackAsync(pack_:bigint, unpack_:LPXConfigPack): Promise<any>
    {
        const result = await this._call('getPackConfigPack', pack_+"", unpack_); 
        return result;
    }

    //function poolCreate(ILPXv1.Config calldata config_, uint256 poolId_) external payable {
    async poolCreateAsync(config:LPXConfig, poolId:bigint, valueEth="0"): Promise<any>
    {
        const result = await this._pay(this._toWei(valueEth), 'poolCreate', config, poolId+""); 
        return result;
    }


   
    async poolStart(valueEth:string, poolId:number, reserves:LPXReserves): Promise<any>
    {
        const result = await this._pay(this._toWei(valueEth), 'poolStart', poolId, reserves); 
        return result;
    }

    async addLiquidity(valueEth:string, poolId:number, fundValueEth:string, anchorValueEth:string): Promise<any>
    {
        const result = await this._pay(this._toWei(valueEth), 'addLiquidity', poolId, this._toWei(fundValueEth), this._toWei(anchorValueEth)); 
        return result;
    }

   // function claimProfits(uint256 poolId_, address[] calldata forUsers_, bool unsafe_) external lockThread {

    async claimProfits(poolId:number[], unsafe:boolean=false): Promise<any>
    {
        const result = await this._send('claimProfits',poolId, unsafe); 
        return result;
    }


    async removeLiquidity(poolId:number, partEth:string): Promise<any>
    {
        const result = await this._send('removeLiquidity', poolId+"", this._toWei(partEth)); 
        return result;
    }


    async getProfit(poolId:number, forAddress:string)
    {
        const res = await this._call("getProfit", poolId, forAddress);
        return this._toDecimal(res);
    }



    // async getPoolsByIds(poolsIds:number[]): Promise<LPXInfo>
    // {
    //     const response = await this._call("getPoolsByIds", poolsIds);
    //     if (!response) return;
    //     const pools = response as LPXInfo;
    //     const result = new LPXInfo();
    //     result.reserves_ = [];
    //     result.configs_ = [];
    //     for(let i=0;i<pools.configs_.length;i++)
    //     {
    //         let reserve = pools.reserves_[i];
    //         let config = pools.configs_[i];
    //         const res = new LPXReserves();
    //         res.fundReserve = this._toDecimal(reserve.fundReserve);
    //         res.fundImgReserve = this._toDecimal(reserve.fundImgReserve);
    //         res.anchorReserve = this._toDecimal(reserve.anchorReserve);
    //         res.anchorImgReserve = this._toDecimal(reserve.anchorImgReserve);
    //         result.reserves_.push(res);
    //         const cfg = new LPXConfig();
    //         cfg.manager = config.manager;
    //         cfg.fundToken = config.fundToken;
    //         cfg.anchorToken = config.anchorToken;
    //         cfg.ntzIndex = this._toDecimal(config.ntzIndex);
    //         cfg.rewardIndex = this._toDecimal(config.rewardIndex);
    //         cfg.startRatio = this._toDecimal(config.startRatio);
    //         cfg.sellRatio = this._toDecimal(config.sellRatio);
    //         cfg.totalShares = this._toDecimal(config.totalShares);
    //         result.configs_.push(cfg);
    //     }
    //     return result;
    // }

    // async lastPoolId()
    // {
    //     return await this._call("lastPoolId");
    // }

    // async share(poolId:number, address:string)
    // {
    //     const res = await this._call("share", poolId, address);
    //     return this._toDecimal(res);
    // }

}
